import React from 'react'
import Autosuggest from 'react-autosuggest'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import { TextField, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import {
  getSuggestionValue,
  getSectionSuggestions,
} from '../../../Utils/GlobalSearch/GlobalSearchUtils'
import SearchIcon from '../../../Assets/Images/icons/globalSearch'
import styles from '../styles'
import { ROLE_DISTRIBUTOR } from '../../../shared/constants'
import classNames from 'classnames'
import { Chip } from 'material-ui'
import RoleLabel from '../../RoleLabel'

const renderInputComponent = ({ classes, ...other }) => (
  <TextField
    fullWidth
    InputProps={{
      classes: {
        input: classes.input,
      },
      disableUnderline: true,
    }}
    {...other}
  />
)

const renderSectionTitle = section => {
  return section.results.length ? (
    <div
      style={{ padding: '12px', fontSize: '14px', color: 'gray' }}
      cypress_id={'titleOfSearchListItems'}
    >
      {section.title}
    </div>
  ) : null
}

const renderSuggestion = (suggestion, { query, isHighlighted }) => {
  const suggestionLabel = getSuggestionValue(suggestion)
  const matches = match(suggestionLabel, query)
  const parts = parse(suggestionLabel, matches)
  return (
    <MenuItem
      selected={isHighlighted}
      component="div"
      style={{ paddingTop: '0px', paddingBottom: '0px', whiteSpace: 'pre' }}
    >
      {parts.map((part, index) => {
        return part.highlight ? (
          <div
            key={String(index)}
            style={{
              fontSize: '14px',
              fontWeight: 500,
            }}
          >
            {part.text}
          </div>
        ) : (
          <div
            key={String(index)}
            style={{
              fontSize: '14px',
              fontWeight: 300,
            }}
          >
            {part.text}
          </div>
        )
      })}
    </MenuItem>
  )
}

const ChatParticipantsSearchView = ({
  classes,
  suggestions,
  onChange,
  onSuggestionSelected,
  handleSuggestionsFetchRequested,
  handleSuggestionsClearRequested,
  inputValue,
  onUserClick,
  selectedParticipants,
  placeholder,
  showButton,
}) => {
  const autosuggestProps = {
    renderInputComponent,
    suggestions,
    onSuggestionSelected,
    onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
    onSuggestionsClearRequested: handleSuggestionsClearRequested,
    getSuggestionValue,
    renderSuggestion,
    getSectionSuggestions,
    renderSectionTitle,
    multiSection: true,
    alwaysRenderSuggestions: true,
    focusInputOnSuggestionClick: false,
    theme: {
      container: classes.container,
      suggestionsContainerOpen: classes.suggestionsContainerOpen,
      suggestionsList: classes.suggestionsList,
      suggestion: classes.suggestion,
    },
    inputProps: {
      classes,
      placeholder: placeholder || 'Search Anything',
      value: inputValue,
      onChange,
    },
    renderSuggestionsContainer: options => <div />,
  }
  return (
    <div className={classes.root}>
      <div
        className={classes.inputContainer}
        cypress_id={'searchInputInNewChatModal'}
      >
        {showButton && (
          <div className={classes.icon}>
            <SearchIcon onClick={handleSuggestionsFetchRequested} />
          </div>
        )}
        <Autosuggest {...autosuggestProps} />
      </div>
      <div className={classes.chipsContainer}>
        {selectedParticipants.map(({ id, name }) => {
          return (
            <Chip
              size={'small'}
              style={{
                marginLeft: 14,
                borderRadius: 4,
                border: `1px solid #E2E2FC`,
                fontSize: 16,
                fontFamily: "'Proxima Nova', sans-serif",
                color: '#011533',
                backgroundColor: '#E2E2FC',
                marginBottom: 4,
              }}
              label={name}
              onRequestDelete={() => {
                onUserClick({ id, name })
              }}
              cypress_id={'participantNameOnTab'}
            >
              {name}
            </Chip>
          )
        })}
      </div>
      <div
        className={classes.suggestionsContainer}
        cypress_id={'suggestionsContainer'}
      >
        {suggestions.length > 0
          ? suggestions[0].results.map(({ item }) => {
              const alreadySelected = selectedParticipants.find(
                ({ id }) => id == item.id,
              )
              return (
                <div
                  className={classNames({
                    [classes.userRow]: true,
                    [classes.userRowActive]: alreadySelected,
                  })}
                  onClick={() =>
                    onUserClick({
                      id: item.id,
                      name: item.name,
                      role: item.role,
                      cityId: item.cityId,
                      profilePicture: item.profilePicture,
                    })
                  }
                  cypress_id={'participantItem'}
                >
                  <span>{item.name}</span>
                  {item.role !== ROLE_DISTRIBUTOR && (
                    <RoleLabel role={item.role} />
                  )}
                </div>
              )
            })
          : null}
      </div>
    </div>
  )
}

export default withStyles(styles)(ChatParticipantsSearchView)
